import { useCallback, useEffect, useState } from "react";
import { CashSalesResponse } from "../types/sale.type";
import { getCashSalesDetail } from "../services";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import DetailsFooter from "../components/Sales/CashSales/Details/Footer";
import CashSalesDetails from "../components/Sales/CashSales/Details";
import DocumentSkeleton from "../components/Sales/CashSales/Details/Skeleton";
import VersionSelector from "../components/Sales/VersionSelector";
import { salesListReturnPath } from "../components/Sales/salesListUrl";
import { useTransactionVersions } from "../utils/hooks/useTransactionVersions";

export default function CashSalesDetailsPage() {
  const { cashSalesId } = useParams<{ cashSalesId: string }>();
  const [searchParams] = useSearchParams();
  const [cashSales, setCashSales] = useState<CashSalesResponse>();
  const [triggerFetch, setTriggerFetch] = useState<number>(0);
  const { versions, selected, setSelected, versionParam } =
    useTransactionVersions(cashSalesId);

  const getCashSalesDetails = useCallback(
    async (cashSalesId: string, version?: number) => {
      const {
        data: { data },
      } = await getCashSalesDetail(cashSalesId, version);
      setCashSales(data);
    },
    [],
  );

  useEffect(() => {
    cashSalesId && getCashSalesDetails(cashSalesId, versionParam);
  }, [triggerFetch, cashSalesId, versionParam, getCashSalesDetails]);

  if (!cashSales) return <DocumentSkeleton />;

  const salesListPath = salesListReturnPath(searchParams);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          <Link
            to={salesListPath}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              การขาย
            </Typography>
          </Link>
          <Typography variant="body1" sx={{ mx: 1 }}>
            /
          </Typography>
          <Typography variant="body1" color="primary">
            {cashSales?.order_no}
          </Typography>
        </Box>
        <VersionSelector
          versions={versions}
          selected={selected}
          onChange={setSelected}
        />
      </Box>
      <CashSalesDetails
        cashSales={cashSales}
        setTriggerFetch={setTriggerFetch}
      />
    </Box>
  );
}
